import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Modal from "react-modal";
import { Container, Row, Col } from "react-bootstrap";
import { selectUser } from "../../components/auth/auth.selector";
import HelmetWrapper from "../../HelmetWrapper";
import ModalHeadAndClose from "../../components/payouts-wtf/common/ModalHeadAndClose";
import SegementForm from "../../components/trigger-system/ris/segments/SegementForm";
import CommonStructured from "../../components/common-components/CommonStructured";
import SegmentListings from "../../components/trigger-system/ris/segments/SegmentListings";
import "../../styles/trigger-system/ris-segment.css";
import { fetchSegmentsData } from "../../redux/transfer-reducers/transferSlice";

const SegmentOfferMapping = () => {
  const dispatch = useDispatch();
  const userInfoData = useSelector(selectUser);

  const { triggers, triggersLoading, triggersError } = useSelector(
    (state) => state.plans
  );

  const [isPage, setIsPage] = useState(0);
  const [pageLimit, setPageLimit] = useState(10);

  const iniAllFilter = {
    searchString: "",
  };
  const [allFilters, setAllFilters] = useState(iniAllFilter);
  const iniFilters = {
    page: isPage + 1,
    limit: pageLimit || 10,
  };
  const [filters, setFilters] = useState(iniFilters);
  const [searchFilterApplied, setSearchFilterApplied] = useState(false);

  const iniModValues = {
    isModOpen: false,
    modName: "",
    rowData: "",
  };
  const [modValues, setModValues] = useState(iniModValues);

  const onClickSearch = () => {
    setIsPage(0);
    if (allFilters.searchString) {
      setSearchFilterApplied(true);
      setFilters((prevs) => ({ ...prevs, search: allFilters.searchString }));
    }
  };

  const onResetFilters = () => {
    setAllFilters(iniAllFilter);
    setFilters(iniFilters);
  };

  const onCloseModal = () => {
    setModValues(iniModValues);
  };

  const getSegmentsData = (filters) => {
    dispatch(
      fetchSegmentsData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  };

  useEffect(() => {
    getSegmentsData(filters);
  }, [filters]);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      page: isPage + 1,
      limit: pageLimit || 10,
    }));
  }, [isPage, pageLimit]);

  useEffect(() => {
    if (allFilters.searchString?.length === 0) {
      setSearchFilterApplied(false);
      setFilters((prevs) => ({ ...prevs, search: "" }));
      setIsPage(0);
    }
  }, [allFilters.searchString]);

  return (
    <HelmetWrapper title="WTF: Segment Offer Mapping">
      <Container className="bg-cloud-k px-50px gobal-container" fluid>
        <Modal
          isOpen={modValues.isModOpen}
          onRequestClose={onCloseModal}
          contentLabel="Detail Modal"
          ariaHideApp={false}
        >
          {/* <div className="createNewCTOModalContainer">
            <ModalHeadAndClose
              title={
                modValues.modName === "add" || modValues.modName === "edit"
                  ? `${modValues.modName} Trigger`
                  : modValues.modName === "offer-days"
                  ? `${modValues.rowData?.type}(${modValues.rowData?.category})`
                  : modValues.modName?.replace(/_/g, " ")
              }
              onClose={onCloseModal}
            /> */}

          {modValues.modName === "description" ? (
            <div className="discussionModalMessage mt30">
              <p className="message">
                {modValues.rowData?.description || "No Content Available"}
              </p>
            </div>
          ) : modValues.modName === "add" || modValues.modName === "edit" ? (
            <SegementForm
              isEdit={modValues.modName === "edit"}
              rowData={modValues.rowData}
              closeModal={onCloseModal}
              userInfoData={userInfoData}
              callFunction={() => getSegmentsData(filters)}
            />
          ) : null}
          {/* </div> */}
        </Modal>

        <Row>
          <Col>
            <CommonStructured
              pageHeading={"Segment Offer Mapping"}
              isReload={() => getSegmentsData(filters)}
              createBtnTxt={"+ Add New Segment"}
              onClickCreateBtn={() =>
                setModValues((prevs) => ({
                  ...prevs,
                  isModOpen: true,
                  modName: "add",
                }))
              }
            />
          </Col>
        </Row>

        {/* <Row>
          <Col>
            <CmnFilters
              from="triggers"
              userInfoData={userInfoData}
              searchFilterApplied={searchFilterApplied}
              filters={allFilters}
              setFilters={setAllFilters}
              onClickSearch={onClickSearch}
              onClickReset={onResetFilters}
              isLoading={centralisedPlanCategoriesLoading}
              searchPlaceHolder="Search by category name..."
            />
          </Col>
        </Row> */}

        <Row>
          <Col>
            <SegmentListings
              isPage={isPage}
              setIsPage={setIsPage}
              pageLimit={pageLimit}
              setPageLimit={setPageLimit}
              setModValues={setModValues}
              userInfoData={userInfoData}
              callFunction={() => getSegmentsData(filters)}
            />
          </Col>
        </Row>
      </Container>
    </HelmetWrapper>
  );
};

export default SegmentOfferMapping;
